import React from "react";
import styled from "styled-components";
const Portfolio = () => {
  return (
    <Wrapper
    initial={{ opacity: 0, translateY: 20 }} // Initial animation state
    animate={{ opacity: 1, translateY: 0 }} // Animation to perform
    transition={{ duration: 0.5 }} // Animation duration
  >
    <div className="project flex">
      <p className="pname">School.in</p>
      <p className="ptitle">
        about designing thoughtful experiences and interfaces to make sure that users are satisfied while using your
        product. I'm a self taught designer and have learnt the UI/UX concepts and processes by attending online
        courses, workshops, reading books, and applying them to different projects.
      </p>
      <div className="tag flex">
        <p>Reactjs</p>
        <p>Nodejs</p>
      </div>
      <div className="pimg">
        <img src="./images/p.jpg" alt="" />
      </div>
    </div>
  </Wrapper>
  );
};

const Wrapper = styled.section`
  @media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    width: 100%;
    height: fit-content;
  }
  @media (max-width: 480px) {
    width: 100%;
    height: fit-content;
  }
  width: 350px;
  height: fit-content;
  border: 2px solid #66bcf115;
  border-radius: 15px;
  color: white;
  padding: 20px;
  cursor: pointer;
  transition: all ease 0.2s;

  :hover {
    background-color: #11117675;
  }
  .project {
    font-family: "Fira Code", monospace;
    flex-direction: column;
    gap: 15px;
    .project-action {
      display: flex;
      gap: 10px;
      a {
        border-radius: 10px;
        text-decoration: none;
        color: #0c0842;
        padding: 7px 8px;
        font-weight: 500;
        background-color: #cbebf2cf;
        border: 1px solid #0c0842;
        :hover {
          background-color: #0c0842;
          color: #cbebf2;
        }
      }
    }
    .pname {
      font-size: 1.3rem;
      font-family: "Fira Code", monospace;
      font-weight: 500;
      letter-spacing: 1px;
      @media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        font-size: 2.5rem;
      }
      @media (max-width: 480px) {
        font-size: 2rem;
      }
    }
    .ptitle {
      font-family: "Fira Code", monospace;

      font-size: 0.9rem;
      color: #ffffff7b;
      display: box;
      line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3; /* number of lines to show */
      line-clamp: 3;
      -webkit-box-orient: vertical;
      font-weight: 200;
      @media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        font-size: 1.7rem;
      }
      @media (max-width: 480px) {
        font-size: 1.2rem;
      }
    }
    .pimg img {
      width: 310px;
      border-radius: 15px;
      @media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        width: 100%;
      }
    }
    .tag {
      gap: 10px;
      p {
        padding: 5px 9px;
        background-color: #11117699;
        border-radius: 10px;
        color: #b1b1f2d0;
        font-family: "Fira Code", monospace;
        @media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
          font-size: 1.7rem;
        }
        @media (max-width: 480px) {
          font-size: 1.2rem;
        }
      }
    }
  }
`;
export default Portfolio;
